import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import RoomDisplay from "@/pages/RoomDisplay";
import RoomsSettings from "@/pages/RoomsSettings";
import ReunioesAdmin from "@/pages/ReunioesAdmin";
import AgendarPage from "@/pages/AgendarPage";
import EmailSettings from "@/pages/EmailSettings";
import AdminUsersPage from "@/pages/AdminUsersPage";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import AdminBrandingPage from "@/pages/AdminBrandingPage";
import EmailSelectionPage from "@/pages/EmailSelectionPage";
import ManualEmailBookingPage from "@/pages/ManualEmailBookingPage";
import EmailApprovalsPage from "@/pages/EmailApprovalsPage";
import PublicManualEmailBookingPage from "@/pages/PublicManualEmailBookingPage";
import PublicEmailApprovalPage from "@/pages/PublicEmailApprovalPage";
import PublicDisplayCustomizationPage from "@/pages/PublicDisplayCustomizationPage";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/login" />;
  }
  return user.is_admin ? children : <Navigate to="/dashboard" />;
};

function App() {
  return (
    <BrandingProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/agendar" element={<AgendarPage />} />
            <Route path="/email/selecao/:token" element={<EmailSelectionPage />} />
            <Route path="/email/manual-public/:token" element={<PublicManualEmailBookingPage />} />
            <Route path="/email/aprovacao/:token" element={<PublicEmailApprovalPage />} />
            <Route path="/email/display-customization/:token" element={<PublicDisplayCustomizationPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configuracoes/salas"
              element={
                <ProtectedRoute>
                  <RoomsSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configuracoes/email"
              element={
                <ProtectedRoute>
                  <EmailSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/email/manual/:emailId"
              element={
                <ProtectedRoute>
                  <ManualEmailBookingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/reunioes"
              element={
                <ProtectedRoute>
                  <ReunioesAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/usuarios"
              element={
                <AdminRoute>
                  <AdminUsersPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/branding"
              element={
                <AdminRoute>
                  <AdminBrandingPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/aprovacoes-email"
              element={
                <AdminRoute>
                  <EmailApprovalsPage />
                </AdminRoute>
              }
            />
            <Route path="/sala/:roomId" element={<RoomDisplay />} />
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </BrandingProvider>
  );
}

export default App;
